function n(r) {
  return Array.isArray(r) && r.length > 0;
}
export {
  n as arrayHasLength
};
